/* Small shared helpers — identity, colors, time. No app state here. */

export const PALETTE = [
  '#ECA63E', '#6CA8E0', '#E2674A', '#74C97A', '#B488E6', '#62B6A4',
  '#F0A86E', '#C58FE0', '#8FB4E8', '#E58FB0', '#7FC9C0', '#5FB0D6', '#D98C6A', '#EBB55E',
]

export function colorFor(id: string): string {
  let h = 0
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) >>> 0
  return PALETTE[h % PALETTE.length]
}

export function localpart(mxid: string): string {
  return (mxid || '').replace(/^@/, '').split(':')[0]
}

export function domainOf(mxid: string): string {
  return (mxid || '').split(':')[1] || ''
}

export function shortName(name: string | null | undefined, mxid: string): string {
  return name ? name.trim().split(/\s+/)[0] : localpart(mxid)
}

export function initials(name: string): string {
  const parts = (name || '').trim().split(/[\s-]+/).filter(Boolean)
  if (!parts.length) return '?'
  const first = parts[0][0]
  const last = parts.length > 1 ? parts[parts.length - 1][0] : ''
  return (first + last).toUpperCase()
}

export function botMxid(myUserId: string | undefined): string {
  const uid = myUserId || ''
  return '@atrium:' + domainOf(uid)
}

/** Real MatrixRTC keys membership as "_@user:domain_DEVICE"; tolerate that and
 *  the simpler "@user:domain" the web client publishes itself. */
export function rtcMemberMxid(stateKey: string): string | null {
  if (!stateKey) return null
  if (stateKey[0] === '@') return stateKey
  const m = stateKey.match(/_(@[^_]+:[^_]+)_/)
  return m ? m[1] : null
}

export function relativeAgo(ts: number): string {
  const s = Math.max(0, Math.floor((Date.now() - ts) / 1000))
  if (s < 45) return 'just now'
  if (s < 3600) return Math.floor(s / 60) + 'm ago'
  if (s < 86400) return Math.floor(s / 3600) + 'h ago'
  return Math.floor(s / 86400) + 'd ago'
}

export function greeting(): string {
  const h = new Date().getHours()
  return h < 12 ? 'Good morning' : h < 18 ? 'Good afternoon' : 'Good evening'
}

/** Humanize a duration in ms: "3w 2d", "2d 4h", "3h 12m", "45m", "<1m". */
export function fmtDuration(ms: number): string {
  const m = Math.floor(ms / 60000)
  if (m < 1) return '<1m'
  if (m < 60) return m + 'm'
  const h = Math.floor(m / 60)
  if (h < 24) return h + 'h' + (m % 60 ? ` ${m % 60}m` : '')
  const d = Math.floor(h / 24)
  if (d < 7) return d + 'd' + (h % 24 ? ` ${h % 24}h` : '')
  const w = Math.floor(d / 7)
  return w + 'w' + (d % 7 ? ` ${d % 7}d` : '')
}
